<div class="tam-contact-control">
    <kendo-dropdownlist [style.width.px]="childConfig.css.width" [popupSettings]="{appendTo: 'component'}" #dropDownEl
        class="contact-dropdown" [disabled]="true" [readonly]="true">
        <ng-template kendoMultiSelectHeaderTemplate>
            <div class="popup-template-clear-header">
                <span class="multiselect-Clear">Clear</span>
            </div>
        </ng-template>
    </kendo-dropdownlist>
</div>